import {useId} from 'react'

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string
  error?: string
}

const Input = (props: Props) => {
  const {type = 'text', label, error, autoComplete, className, style, ...rest} = props
  const id = useId()

  return (
    <div className='w-100'>
      {label && <label className='form-label fw-semibold text-dark fs-6'>{label}</label>}

      <input
        id={id}
        type={type}
        autoComplete={autoComplete ?? 'off'}
        className={`form-control bg-transparent ${error ? 'is-invalid' : ''}`}
        style={{
          ...style,
        }}
        {...rest}
      />

      {error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{error}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default Input
